var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1"}),(_vm.isAdmins)?_c('select-hospital',{attrs:{"hospitals":_vm.hospitals}}):_c('Add',{staticClass:"mb-4",on:{"click":_vm.open}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }